import React, { Component } from "react";

export default class SrtViewerClass extends Component {
  formatSrt(srt) {
    if (!srt) return [];

    // Sépare les blocs de sous-titres par double saut de ligne
    const blocks = srt
      .trim()
      .split(/\r?\n\s*\r?\n/)
      .map((block) => {
        const lines = block.split(/\r?\n/);
        const index = lines[0];
        const time = lines[1];
        const text = lines.slice(2).join("\n"); // <-- garde les retours à la ligne !
        return { index, time, text };
      });

    return blocks;
  }

  render() {
    const { srt } = this.props;
    const subtitles = this.formatSrt(srt);

    const containerStyle = {
      background: "#0d1117",
      color: "#c9d1d9",
      padding: "1rem",
      borderRadius: "0.75rem",
      fontFamily: "JetBrains Mono, Fira Code, monospace",
      lineHeight: "1.5em",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    };

    const indexStyle = { color: "#58a6ff", fontWeight: "bold" };
    const timeStyle = { color: "#8b949e", fontStyle: "italic" };
    const textStyle = { color: "#dcdcdc", whiteSpace: "pre-line" }; // <-- conserve les \n visuellement

    return (
      <div style={containerStyle}>
        {subtitles.map((sub, i) => (
          <div key={i} style={{ marginBottom: "0.75rem" }}>
            <div style={indexStyle}>{sub.index}</div>
            <div style={timeStyle}>{sub.time}</div>
            <div style={textStyle}>{sub.text}</div>
          </div>
        ))}
      </div>
    );
  }
}
